import { useEffect } from "react";
import "@/assets/styles/Snackbar.css";

const Snackbar = ({ message, type = "info", duration = 3000, onClose }) => {
	useEffect(() => {
		const timer = setTimeout(() => {
			onClose?.();
		}, duration);
		return () => clearTimeout(timer);
	}, [duration, onClose]);

	if (!message) return null;

	return (
		<div className={`snackbar snackbar-${type}`}>
			{message.split('<br>').map((line, index) => (
				<div key={index}>{line}</div>
			))}
		</div>
	);
};

export default Snackbar;
